<template>
  <v-app-bar flat :fixed="isXs">
    <v-app-bar-nav-icon @click="toggleSidebar" class="d-flex d-lg-none"></v-app-bar-nav-icon>
    <v-toolbar-title class="pl-0 fill-height" >
      <template v-if="clientSettings.logo">
        <img :src="clientSettings.logo" style="max-height:100%; width: 100%" :alt="clientSettings.completeName"/>
      </template>
      <template v-else>
        <h1 class="pl-2 pl-lg-0 d-none d-sm-flex">{{clientSettings.completeName}}</h1>
        <h1 class="d-flex d-sm-none pt-2">{{clientSettings.shortName}}</h1>
      </template>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-menu
      left
      bottom
      :offset-y="true"
      content-class="white"
    >
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <v-avatar>
              <v-img :src="clientSettings.shortLogo" contain/>
            </v-avatar>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{userData.name}}</v-list-item-title>
            <v-list-item-subtitle class="text-caption" v-if="userData.plan">
              Current plan: <v-chip x-small :color="userData.plan.class">{{userData.plan.name.toLowerCase()}}</v-chip>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-list dense>

        <v-list-item @click="goToSettings">
          <v-list-item-icon>
            <v-icon>mdi-tune-vertical</v-icon>
          </v-list-item-icon>
          <v-list-item-content>Settings</v-list-item-content>
        </v-list-item>

        <v-list-item @click="goToPlans">
          <v-list-item-icon>
            <v-icon>mdi-shield-star-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>Plans</v-list-item-content>
        </v-list-item>

        <v-list-item @click="logout">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>Logout</v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
  import {getBreakpoint} from "../../helpers/helpers";

  export default {
    name: "icevergHeader",
    computed: {
      isXs() {
        return getBreakpoint(this) === 'xs';
      },
      isXl() {
        return getBreakpoint(this) === 'lg' || getBreakpoint(this) === 'xl';
      },
      clientSettings(){
        return this.$store.getters.getSettingsFromToken;
      },
      userData(){
        return this.$store.getters.getUserFromToken;
      }
    },
    methods: {
      logout() {
        this.$store.dispatch('logout');
      },
      goToSettings() {
        this.$router.push({name: 'settings'});
      },
      goToPlans() {
        this.$router.push({name: 'plans'});
      },
      toggleSidebar(){
        this.$store.dispatch('toggleSidebar', true);
      }
    },
    mounted() {
      if (this.isXl) {
        this.toggleSidebar();
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Header/icevergHeader.vue